import { Injectable } from '@angular/core';
import {
  AllocationSheetsServiceProxy,
  CopyConditionsToAllWorkDaysInput,
  StaffsAndUsersServiceProxy,
  UpdateEventsForWorkDayInput,
  UpdateLocationForWorkDayInput,
  UpdateWorkSummaryForWorkDayInput,
  UpdateRainfallForWorkDayInput,
  UpdateShiftEndForWorkDayInput,
  UpdateShiftStartForWorkDayInput,
  UpdateWeatherConditionsForWorkDayInput,
  ImpactedWorkEventEditDto,
  UpdateNightShiftForWorkDayInput
} from '@shared/service-proxies/service-proxies';
import * as moment from 'moment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AllocationConditionsFormFacade {
  constructor(
    private _staffsAndUsersServiceProxy: StaffsAndUsersServiceProxy,
    private _allocationSheetsServiceProxy: AllocationSheetsServiceProxy
  ) {}

  updateRainfall(
    allocationSheetId: string,
    workDay: moment.Moment,
    rainfall: number
  ): Observable<any> {
    const params = new UpdateRainfallForWorkDayInput({
      allocationSheetId,
      workDay,
      rainfall,
    });

    return this._allocationSheetsServiceProxy.updateRainfallForWorkDay(params);
  }

  updateWeatherConditions(
    allocationSheetId: string,
    workDay: moment.Moment,
    weatherPhenomenaIds
  ): Observable<any> {
    const params = new UpdateWeatherConditionsForWorkDayInput({
      allocationSheetId,
      workDay,
      weatherPhenomenaIds,
    });

    return this._allocationSheetsServiceProxy.updateWeatherConditionsForWorkDay(
      params
    );
  }

  updateShiftEnd(
    _value,
    allocationSheetId: string,
    workDay: moment.Moment,
    shiftEnd
  ): Observable<any> {
    if (!_value || _value == '') return;

    let shiftEndAt = null;
    if (moment(_value, ['HH:mm']).isValid()) {
      shiftEndAt = moment(_value, ['h:mm A']);
    }

    if (!shiftEndAt) return;

    const params = new UpdateShiftEndForWorkDayInput({
      allocationSheetId,
      workDay,
      shiftEnd,
    });

    return this._allocationSheetsServiceProxy.updateShiftEndForWorkDay(params);
  }

  updateShiftStart(
    _value,
    allocationSheetId: string,
    workDay: moment.Moment,
    shiftStart
  ): Observable<any> {
    if (!_value || _value == '') return;
    let shiftStartAt = null;
    if (moment(_value, ['HH:mm']).isValid()) {
      shiftStartAt = moment(_value, ['h:mm A']);
    }

    if (!shiftStartAt) return;

    const params = new UpdateShiftStartForWorkDayInput({
      allocationSheetId,
      workDay,
      shiftStart,
    });

    return this._allocationSheetsServiceProxy.updateShiftStartForWorkDay(
      params
    );
  }

  updateNightShift(
    allocationSheetId: string,
    workDay: moment.Moment,
    nightShift
  ): Observable<any> {
    const params = new UpdateNightShiftForWorkDayInput({
      allocationSheetId,
      workDay,
      nightShift,
    });
    return this._allocationSheetsServiceProxy.updateNightShiftForWorkDay(params);
  }

  updateLocation(
    allocationSheetId: string,
    workDay: moment.Moment,
    locationId: string
  ): Observable<any> {
    const params = new UpdateLocationForWorkDayInput({
      allocationSheetId,
      workDay,
      locationId,
    });

    return this._allocationSheetsServiceProxy.updateLocationForWorkDay(params);
  }

  updateWorkSummary(
    allocationSheetId: string,
    workDay: moment.Moment,
    workSummary: string
  ): Observable<any> {
    const params = new UpdateWorkSummaryForWorkDayInput({
      allocationSheetId,
      workDay,
      workSummary,
    });

    return this._allocationSheetsServiceProxy.updateWorkSummaryForWorkDay(params);
  }

  updateImpactedWork(
    allocationSheetId: string,
    workDay: moment.Moment,
    events:ImpactedWorkEventEditDto[]
  ): Observable<any> {
    const params = new UpdateEventsForWorkDayInput({
      allocationSheetId,
      workDay,
      events,
    });

    return this._allocationSheetsServiceProxy.updateEventsForWorkDay(params);
  }

  copyConditionsToAllWorkDays(
    allocationSheetId: string,
    sourceWorkDay: moment.Moment
  ): Observable<any> {
    const params = new CopyConditionsToAllWorkDaysInput({
      allocationSheetId,
      sourceWorkDay,
    });

    return this._allocationSheetsServiceProxy.copyConditionsToAllWorkDays(
      params
    );
  }
}
